import { CLEAR_SELECTED_GRADE_RECORD } from '../actionTypes'

export * from './CRUD'

export const clearSelectedGradeRecord = () => {
  return { type: CLEAR_SELECTED_GRADE_RECORD }
}
